import { createFileRoute } from '@tanstack/react-router'
import { useDocumentTitle } from 'usehooks-ts'

import { useAuth } from '@/services/auth/auth.store'
import { trackDetails } from '@/services/track/track.gql'

import {
  TrackDetailsAbout,
  TrackDetailsHeader,
  TrackDetailsLessons,
  TrackDetailsMentor,
  TrackOverview,
} from '@/components/view/track/track-details'

export const Route = createFileRoute('/(app)/track/$trackid/')({
  async loader({ context, params }) {
    const { isAuthenticated } = useAuth.getState()
    await context.qc.ensureQueryData(
      trackDetails.qry({ myTrack: isAuthenticated, trackId: params.trackid })
    )
  },
  component: RouteComponent,
})

function RouteComponent() {
  useDocumentTitle('Kelas - Yes LMS')

  return (
    <div
      className="flex grow flex-col gap-4 bg-[#FFF3F3] pb-16"
      style={
        {
          '--grid-cols-temp-lg': 'auto 330px',
        } as React.CSSProperties
      }
    >
      <TrackDetailsHeader />
      <div className="container grid gap-4 lg:grid-cols-(--grid-cols-temp-lg)">
        <div className="order-1 lg:order-2">
          <div className="top-20 lg:sticky lg:-mt-32">
            <TrackOverview />
          </div>
        </div>
        <div className="order-2 flex grow flex-col gap-4 lg:order-1">
          {/* <TrackDetailsTabs /> */}
          <TrackDetailsAbout />
          <TrackDetailsLessons />
          <TrackDetailsMentor />
        </div>
      </div>
    </div>
  )
}
